import React, { useState } from "react";
import commercial1 from "../../Assets/Builders.webp";
import residential from "../../Assets/ourworks/project1.png";
import residential1 from "../../Assets/ourworks/project2-225x215.jpg";
import residential2 from "../../Assets/ourworks/project3-225x215.jpg";
import residential3 from "../../Assets/ourworks/1-kk-nagar-house-exterior-1-225x215.jpg";
import residential4 from "../../Assets/ourworks/FINAL-VIEW-KAMALUDEEN-225x215.jpg";
import residential5 from "../../Assets/ourworks/bangaloe-project-elevation-225x215.jpg";
import residential6 from "../../Assets/ourworks/hosur-project-225x215.jpg";
import residential7 from "../../Assets/ourworks/project4-225x215.png";
import residential8 from "../../Assets/ourworks/project5-225x215.png";
import residential9 from "../../Assets/ourworks/project6-225x215.jpg";
import residential10 from "../../Assets/ourworks/project7-225x215.png";
import home from "../../Assets/BANNER 4.png";

const imageData = {
  all: [
    { id: 1, src: residential, category: "residential", title: "Residential Project 1", subtitle: "Luxury Villa" },
    { id: 2, src: residential1, category: "residential", title: "Residential Project 2", subtitle: "Luxury Villa 2" },
    { id: 3, src: residential2, category: "residential", title: "Residential Project 3", subtitle: "Modern Apartment" },
    { id: 4, src: residential3, category: "residential", title: "Residential Project 4", subtitle: "1-kk-nagar-house-exterior" },
    { id: 5, src: residential4, category: "residential", title: "Residential Project 5", subtitle: "finalView-Kamaludeen" },
    { id: 6, src: residential5, category: "residential", title: "Residential Project 6", subtitle: "bangalore-project-elevation" },
    { id: 7, src: residential6, category: "residential", title: "Residential Project 7", subtitle: "hosur-project" },
    { id: 8, src: residential7, category: "residential", title: "Residential Project 8", subtitle: "Modern Bungalow" },
    { id: 9, src: residential8, category: "residential", title: "Residential Project 9", subtitle: "Luxury Retreat" },
    { id: 10, src: residential9, category: "residential", title: "Residential Project 10", subtitle: "Classic Residence" },
    { id: 11, src: residential10, category: "residential", title: "Residential Project 11", subtitle: "Stylish Home" },
    { id: 12, src: commercial1, category: "commercial", title: "Commercial Project 2", subtitle: "Shopping Complex" },
  ],    
  commercial: [
    { id: 12, src: commercial1, category: "commercial", title: "Commercial Project 2", subtitle: "Shopping Complex" },
  ],
  residential: [
    { id: 1, src: residential, category: "residential", title: "Residential Project 1", subtitle: "Luxury Villa" },
    { id: 2, src: residential1, category: "residential", title: "Residential Project 2", subtitle: "Luxury Villa 2" },
    { id: 3, src: residential2, category: "residential", title: "Residential Project 3", subtitle: "Modern Apartment" },
    { id: 4, src: residential3, category: "residential", title: "Residential Project 4", subtitle: "1-kk-nagar-house-exterior" },
    { id: 5, src: residential4, category: "residential", title: "Residential Project 5", subtitle: "finalView-Kamaludeen" },
    { id: 6, src: residential5, category: "residential", title: "Residential Project 6", subtitle: "bangalore-project-elevation" },
    { id: 7, src: residential6, category: "residential", title: "Residential Project 7", subtitle: "hosur-project" },
    { id: 8, src: residential7, category: "residential", title: "Residential Project 8", subtitle: "Modern Bungalow" },
    { id: 9, src: residential8, category: "residential", title: "Residential Project 9", subtitle: "Luxury Retreat" },
    { id: 10, src: residential9, category: "residential", title: "Residential Project 10", subtitle: "Classic Residence" },
    { id: 11, src: residential10, category: "residential", title: "Residential Project 11", subtitle: "Stylish Home" },
  ],
};

const OurWorks = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  return (
    <>
      <div className="max-w-screen-2xl mx-auto">
        <img src={home} alt="home" className="w-full h-[300px] object-cover" />
      </div>
      <div className="max-w-screen-xl mx-auto p-4">
        {/* Category Selection */}
        <div className="flex justify-center lg:justify-start space-x-6 mt-6">
          {["all", "commercial", "residential"].map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 text-sm font-medium ${
                selectedCategory === category
                  ? "bg-[#068b07] text-white"
                  : "text-black hover:text-[#068b07]"
              } transition-all duration-300`}
            >
              {category.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-6">
          {imageData[selectedCategory].map((image) => (
            <div key={image.id} className="relative group overflow-hidden">
              <img
                src={image.src}
                alt={image.category}
                className="w-full h-[350px] object-cover cursor-pointer transition-transform duration-300 group-hover:scale-105"
              />
              {/* Text Overlay */}
              <div className="absolute right-0 flex flex-col mx-auto bottom-7">
                <h1 className="text-gray-300 p-2 bg-[#121315] opacity-85 w-40 py-2 text-xs font-medium">
                  {image.title}
                </h1>
                <h2 className="text-black p-2 bg-slate-100 capitalize font-bold py-4 w-[260px] text-md">
                  {image.subtitle}
                </h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurWorks;
